module.exports = __webpack_public_path__ + "media/src/public/img/payment/visa-logo-fef93da67ba760360dbf8084eac450b3.svg";